<div [ngClass]="wallet_detail && wallet_detail.length != 0 ?'main__page':''">
  <ion-refresher slot="fixed" pullFactor="0.5" pullMin="100" pullMax="200">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-title *ngIf="false && !db.ismobile && wallet_detail && wallet_detail.length != 0" class="ion-title">Wallet</ion-title>
  <div class="max-overflow" *ngIf="wallet_detail && wallet_detail.length != 0" #scrollMe (scroll)="onScroll($event)">
    <div class="d__flex">
      <div class="wallet__info total">
        <div class="wallet__title open_sans__font ion-text-center">{{wallet_detail && wallet_detail.total_wallet_amount? ((wallet_detail.total_wallet_amount | number: '1.0-0')) : 0 | currency:db.currency}}</div>
        <div class="wallet__text open_sans__font ion-text-center">Total</div>
      </div>
      <div class="wallet__info current">
        <div class="wallet__title open_sans__font ion-text-center">{{wallet_detail && wallet_detail.current_wallet_amount?((wallet_detail.current_wallet_amount | number: '1.0-0') ): 0 | currency:db.currency}}</div>
        <div class="wallet__text ion-text-center">Current Value</div>
      </div>
      <div class="wallet__info locked">
        <div class="wallet__title open_sans__font ion-text-center">{{wallet_detail && wallet_detail.locked_in_amount? ((wallet_detail.locked_in_amount | number: '1.0-0')) : 0 | currency:db.currency}}</div>
        <div class="wallet__text ion-text-center webkit-text" [style.--line]="1">Locked Amount</div>
      </div>
      <!-- <div class="wallet__info mouse" (click)="deposit()" *ngIf="!db.ismobile">
            <div class="wallet__title ion-text-center webkit-text" [style.--line]="1">Deposit Wallet Amount</div>
            <div class="wallet__text ion-text-center"> <ion-icon name="add-outline"></ion-icon> deposit</div>
        </div> -->
    </div>
    <div class="table__data" *ngIf="wallet_detail && !db.ismobile">
      <div class="order__details">
        <div class="order__id">Order Id</div>
        <div class="transaction__date">Transaction Date</div>
        <div class="status">Status</div>
        <div class="amount">Amount</div>
        <div class="note">Notes</div>
      </div>
      <div class="main-item mouse" *ngFor="let item of wallet_detail.transactions;let i =index">
        <div class="wallet__items" [class.table__container]="!db.ismobile" [class.d__flex]="!db.ismobile" [class.mobile__wallet]="db.ismobile">
          <div class="order__id">{{item.name}}</div>
          <div class="transaction__date">{{item.transaction_date | date:'medium'}}</div>
          <div class="status"><span class="dot" [class.success]="item.status == 'Credited'" [class.shipped]="item.status == 'Shipped'" [class.placed]="item.status == 'Placed'"></span>{{item.status}}</div>
          <div class="open_sans__font" [ngClass]="item.status == 'Credited'?'credited amount credited_amount':'debited amount debited_amount'"> {{item.status == 'Credited'?'+':'-'}} {{item.amount | currency:db.currency}}</div>
          <div class="note">{{item.notes}}</div>
        </div>
      </div>
    </div>
    <div class="table__data" *ngIf="wallet_detail && db.ismobile && wallet_detail && wallet_detail.transactions">
      <div class="main-item mouse" *ngFor="let item of wallet_detail.transactions;let i =index">
        <div class="table__items" [class.mobile__wallet]="db.ismobile">
          <div class="d__just">
            <div>
              <div class="fnt-14">{{item.name}}</div>
              <div class="fnt-11 transaction__date">{{item.transaction_date | date:'medium'}}</div>
            </div>
            <div>
              <div class="open_sans__font fnt-14" [ngClass]="item.status == 'Credited'?'credited':'debited'">{{item.status == 'Credited'?'+':'-'}} {{item.amount | currency:db.currency}}</div>
            </div>
          </div>
          <div class="fnt-10 notes">{{item.notes}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="wallet__img" *ngIf="wallet_detail && wallet_detail.length == 0">
    <img src="assets/icons/wallet-null.svg" alt="">
    <p>Sorry, your wallet is empty..!</p>
  </div>
  <div *ngIf="!db.Wallet_points">
  <!-- <div *ngIf="!db.Wallet_points"> -->
    <div class="d__flex just-a p-10">
      <ion-card class="m0 p5 border w-33" *ngFor="let i of [0,1,2]">
        <p class="p10 m0">
          <ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
        </p>
        <p class="p10 m0">
          <ion-skeleton-text animated style="width: 100%;height: 100%;"></ion-skeleton-text>
        </p>
      </ion-card>
    </div>
    <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7]">
      <ion-label>
        <h3>
          <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
        </h3>
        <p>
          <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
        </p>
        <!-- <p>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </p> -->
      </ion-label>
    </ion-item>
  </div>
</div>
